import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
const faqs = [['¿Necesito ver a un médico o nutricionista para usarlo?', 'No es necesario para comenzar. El protocolo es educativo y práctico. Si tenés una condición médica específica, siempre es bueno comentárselo a tu médico.'], ['¿Los alimentos que se usan son caros o difíciles de conseguir?', 'No. Todo el protocolo está pensado para el mercado argentino. Los ingredientes se consiguen en cualquier súper o verdulería del barrio.'], ['¿En cuánto tiempo empiezo a sentir resultados?', 'Muchas mujeres notan cambios en los primeros 7 días. Los resultados más sostenidos se consolidan con la práctica de las semanas siguientes.'], ['¿La garantía es real?', 'Sí, completamente. Si en 30 días no estás satisfecha, escribinos y te devolvemos el dinero sin preguntas.'], ['¿Es 100% digital?', 'Sí. Recibís acceso inmediato a todos los PDFs por correo electrónico. Podés leerlos desde el celular, la tablet o la computadora, e imprimirlos si preferís.']] as const;
const costs = ['Otro año terminando cada comida con esa incomodidad familiar', 'Seguir eliminando alimentos sin saber realmente cuáles te afectan', 'Sentirte pesada en reuniones, salidas y momentos que deberían ser disfrutables', 'Cansancio de probar cosas sueltas que no funcionan ni se sostienen', 'Otro año sin mapa, sin orden y sin dirección clara'];
const purchases = [['Marta G.', 'Buenos Aires'], ['Silvia R.', 'Córdoba'], ['Norma P.', 'Rosario'], ['Graciela M.', 'Mendoza']];
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-21" data-mp="21ykamj5cbj15">
        <div className="mx-auto max-w-3xl text-center" data-id="element-22" data-mp="1e99itr5ywyz5">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-23" data-mp="19bznxvzt7v3x" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-24" data-mp="1z04ysg706nbd">GARANTÍA 30 DÍAS — SIN PREGUNTAS</h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-25" data-mp="230ylj68plw2o">
            <p className="text-slate-300" data-id="element-26" data-mp="27sgrk8plamui">Aplicás el sistema. Organizás tus comidas y hábitos. Observás el proceso.</p>
            <p className="mt-4 text-slate-300" data-id="element-27" data-mp="2crjkwvw7j4mn">Si en 30 días no es lo que esperabas, te devolvemos el 100%.</p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-28" data-mp="1g22euftbbgkf">Devolución completa</p>
            <p className="mt-2 text-lg font-bold" data-id="element-29" data-mp="1k34gt4em66q3">sin formularios, sin drama.</p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-30" data-mp="1p04eaqxee15l">Tasa de devoluciones: menos del 1%.</p>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-31" data-mp="1typfotodyqvm">
        <div className="mx-auto max-w-3xl" data-id="element-32" data-mp="30ft3loy4jc9k">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-33" data-mp="30j8gcl4bs97t">PREGUNTAS FRECUENTES</h2>
          <div className="mt-10 space-y-3" data-id="element-34" data-mp="tslyb3091l9z">
            {faqs.map(([question, answer], index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-35" data-mp="ovlruqzhmgic" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-36" data-mp="k0fxd3s0rtin">
                    <span data-id="element-37" data-mp="14gcecxglq8k">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-38" data-mp="3sa95if6g2oc5" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-39" data-mp="1qje5tc94a505">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} data-id="element-40" data-mp="1yk3n9e21wisc">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-41" data-mp="1tjo94k9y379b">{answer}</p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-42" data-mp="15t23t0rbs130">
      <div className="mx-auto max-w-4xl" data-id="element-43" data-mp="1aure2e6q4aq1">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-44" data-mp="wu6wtmggimyn">
          ⚖️ ¿CUÁNTO CUESTA NO TENER EL SISTEMA?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-45" data-mp="10vad2a2f2l0e">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-46" data-mp="i9m2s6zr5gun">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-47" data-mp="r9hhglsintzf">
                ×
              </span>
              {item}
            </p>)}
        </div>
        <p className="mt-12 text-center text-xl font-bold" data-id="element-48" data-mp="115c6bync2lan">La próxima semana puede empezar diferente.</p>
        <p className="mx-auto mt-5 max-w-3xl text-center font-display text-xl font-bold italic text-brand-light sm:text-2xl" data-id="element-49" data-mp="w6hoayx6x0rl">
          “Tu cuerpo no está fallando. Solo estaba esperando el orden correcto para responder mejor.” 🌿
        </p>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-50" data-mp="ljhjpraknciw">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-51" data-mp="qcj2499zlu78">
          PROTOCOLO ABDOMEN LIVIANO™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-52" data-mp="108m1x8hd9gr0">
          El sistema de alimentación y hábitos digestivos para mujeres argentinas que quieren sentirse más livianas, cómodas y ordenadas en su vida cotidiana.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-53" data-mp="19892xt66okjj">
          Porque tu cuerpo no está fallando. Solo estaba esperando el acompañamiento correcto.
        </p>

        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-54" data-mp="3b42rd6oc5ppr">
          <a className="hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-55" data-mp="33kk1qhkl6y87">
            📧 soportebiomalivido@gmail.com
          </a>
          <a className="hover:text-brand-light" href="https://www.instagram.com/biomalivido/" target="_blank" rel="noreferrer" data-id="element-56" data-mp="2trw81vowladp">
            📲 @biomalivido
          </a>
          <a className="hover:text-brand-light" href="https://www.biomalivido.com" target="_blank" rel="noreferrer" data-id="element-57" data-mp="3mhbjgmkhd5a5">
            🌐 biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-58" data-mp="3hg5ki7088ls6">© PROTOCOLO ABDOMEN LIVIANO™ 2026 — Todos los derechos reservados.</p>
      </footer>

      <AnimatePresence data-id="element-59" data-mp="38i3efd1mz2y1">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-60" data-mp="38hafgy8x5hqg">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-61" data-mp="50u61dfh9wbc">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-62" data-mp="3n6qh3wwkwtsu" />
              Acceso confirmado
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-63" data-mp="3s6l59soyz5a7">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-slate-300" data-id="element-64" data-mp="jqjjo84rbssi">adquirió Protocolo Abdomen Liviano™</p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-65" data-mp="nqtohhgtcd5s">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}